import {  useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-multi-lang';
import { useReactToPrint } from 'react-to-print';
import PrintTemplate from './print_template';
interface iProps {
  data: any;
  close: Function;
  is_payment: boolean;
}
export const PrintEssal = ({ data, close, is_payment }: iProps) => {
  const t = useTranslation();
  const componenetRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef:  componenetRef,
    onAfterPrint: () => close(),
    documentTitle:'الايصال'
  });
  useEffect(() => {
    handlePrint();
  }, []);

  return (
    <div
      ref={componenetRef as any}
      className="printMe"
      style={{minHeight:'100vh'}}>
        <PrintTemplate
        title_ar={is_payment ? 'ايصال دفع' : 'ايصال قبض'}
        //title_en=   {is_payment ? 'Payment Voucher' : 'Reciept Voucher'}
        >
      
    
    
     
            <Grid  container size={12} justifyContent="center" rowGap={2} paddingTop={0} marginTop={0}>
            <Grid  container size={9} display="flex" justifyContent={'flex-end'}
            alignItems={'center'}>
              {/* <input
                id="delivery_date"
                value={data.date}
                style={{ direction: 'rtl' }}
                className="bottom-border"></input> */}
                <div
               
                 className='fs-12 bolder'
                >
                {data.date?.replaceAll('-','/')}
                </div>
              <div className="label">{t('date')}</div>
            </Grid>
              <Grid  container size={9}
              justifyContent={'flex-end'} alignItems={'center'}
              className='fs-12'>
                {/* <input
                  value={is_payment?data.supplier_name:data.client_name}
                  style={{ flex: 1, margin: '0 5px', direction: 'rtl' }}
                  className="bottom-border"
                /> */}
                <div
                className=' bolder'>{is_payment?data.supplier_name:data.client_name}</div>
                <div className="label text-right">{t('gentlemen')}</div>
              </Grid>
              <Grid  container size={9}
              justifyContent={'flex-end'} alignItems={'center'}
              className='fs-12'>
                {/* <input
                  value={data.voucher_no}
                  style={{ flex: 1, margin: '0 5px', direction: 'rtl' }}
                  className="bottom-border"
                /> */}
                <div 
                   className='bolder'
                >
                {data.voucher_no}
                </div>
                <div className="label text-right">{t('voucher_no')}</div>
              </Grid>
              {!is_payment && (
                <Grid  container size={9}
                justifyContent={'flex-end'} alignItems={'center'}
                className='fs-12'>
                  {/* <input
                    value={data?.order_no}
                    style={{ flex: 1, margin: '0 5px', direction: 'rtl' }}
                    className="bottom-border"
                  /> */}
                  <div 
                      className='bolder'>{data?.order_no +' '+'/Q'}</div>
                  <div className="label">{t('order_no')}</div>
                </Grid>
              )}
              <Grid  container size={9}
                 justifyContent={'flex-end'} alignItems={'center'}
                 className='fs-12'>
                {/* <input
                  value={data.value}
                  style={{ flex: 1, margin: '0 5px', direction: 'rtl' }}
                  className="bottom-border"
                /> */}
                <div 
                      className='bolder'>
                {data.value}
                </div>
                <div className="label text-right">{t('voucher_amount')}</div>
              </Grid>
              <Grid  size={9} container justifyContent={'flex-end'}
              
           >
                <div className="standard-height flex w-full flex-end align_center fs-12">
                  {/* <textarea
                    rows={3}
                    className="bottom-border"
                    value={data?.paragraph}
                    style={{ flex: 1, margin: '0 5px', direction: 'rtl' }}
                  /> */}
                  <div
                
                  className=' bolder'>
                  {data?.paragraph}
                  </div>
                  <div className="label text-right">{t('statement')}</div>
                </div>
              </Grid>
          
            </Grid>
         
     
      
        
  
      </PrintTemplate>
    </div>
  );
};
